import { render, staticRenderFns } from "./kebijakan_umum.vue?vue&type=template&id=3e46f714&"
import script from "./kebijakan_umum.vue?vue&type=script&lang=js&"
export * from "./kebijakan_umum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports